<template>
  <div class="container my-5 package-section">
    <section id="home" class="text-center mb-5 animate__animated animate__fadeInDown">
      <h1 class="fw-bolder text-dark display-4 shadow-text">
        MyTuitionWave.com
      </h1>
      <p class="lead text-secondary fs-5 mt-3">
        The Smart <span class="fw-bolder text-primary">QR-Based</span> Tuition Management System
      </p>
      <a href="#packages&pricing" class="btn btn-lg btn-3d-primary mt-4 shadow-lg hover-grow">
        <i class="bi bi-arrow-right-circle me-2"></i> Explore Packages
      </a>
    </section>


    <section class="mb-5 animate__animated animate__fadeInUp">
      <h3 class="text-primary mb-3 text-center">
        <i class="bi bi-star-fill me-2 icon-3d text-warning"></i>
        Why Choose MyTuitionWave?
      </h3>
      <p class="fs-5 text-muted text-center px-md-5 mx-md-5">
        Managing tuition classes has never been easier! With <b>MyTuitionWave</b>, you can automate
        <span class="text-primary fw-bold">attendance, payments, and student records</span> using
        <b>QR technology</b>—giving you more time to teach and less time on admin work. Our system is
        <span class="text-success fw-bold">cloud-based, secure, and designed for
        teachers, students, and institutes.</span>
      </p>
    </section>


    <section id="packages&pricing" class="mb-5 animate__animated animate__fadeInUp">
      <h3 class="text-primary mb-4 text-center">
        <i class="bi bi-box-seam-fill me-2 icon-3d text-info"></i> Packages & Pricing
      </h3>
      <div class="row g-4 justify-content-center">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="(pkg, i) in packages" :key="i">
          <div class="card package-card text-center shadow-3d hover-3d">
            <div class="card-body p-4">
              <i :class="['bi', pkg.icon, 'text-gradient-primary', 'fs-2', 'mb-2']"></i>
              <h5 class="card-title fw-bold text-dark mt-2">
                {{ pkg.name }}
              </h5>
              <p class="text-muted">{{ pkg.duration }}</p>
              <h3 class="text-success fw-bolder mt-3">{{ pkg.price }}</h3>
              <p class="small text-secondary">{{ pkg.limit }}</p>
              <a href="#contact" class="btn btn-outline-primary mt-3 hover-grow">
                <i class="bi bi-cart-check me-2"></i> Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
      <p class="text-muted mt-4 text-center">
        <i class="bi bi-info-circle-fill me-2"></i> Need more students or subjects? Upgrade easily with
        <b>super discounts</b>!
      </p>
    </section>



    <section id="features" class="mb-5 animate__animated animate__fadeInUp">
      <h3 class="text-primary mb-4 text-center">
        <i class="bi bi-key-fill me-2 icon-3d text-danger"></i> Core Features
      </h3>
      <div class="row g-4">
        <div class="col-md-6">
          <div class="p-4 bg-light rounded shadow-3d hover-3d">
            <h5 class="fw-bold text-dark mb-3">
              <i class="bi bi-person-check-fill me-2 text-success icon-3d"></i> For Teachers & Admins
            </h5>
            <ul class="list-unstyled mt-2 features-list">
              <li><i class="bi bi-graph-up-arrow me-2 text-info"></i> View Attendance (today & history)</li>
              <li><i class="bi bi-currency-dollar me-2 text-success"></i> Track Income (daily, monthly, all-time)</li>
              <li><i class="bi bi-journal-text me-2 text-warning"></i> Student Records (easy to manage)</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <div class="p-4 bg-light rounded shadow-3d hover-3d">
            <h5 class="fw-bold text-dark mb-3">
              <i class="bi bi-building-fill me-2 text-primary icon-3d"></i> For Institutes
            </h5>
            <ul class="list-unstyled mt-2 features-list">
              <li><i class="bi bi-qr-code-scan me-2 text-danger"></i> Scan QR Codes to mark attendance & confirm payment</li>
              <li><i class="bi bi-credit-card-fill me-2 text-primary"></i> Manage Payments effortlessly</li>
              <li><i class="bi bi-people-fill me-2 text-secondary"></i> Student Management with details</li>
            </ul>
          </div>
        </div>
      </div>
    </section>


    <section id="contact" class="text-center bg-light p-5 rounded shadow-lg animate__animated animate__zoomIn">
  <h3 class="text-primary mb-4">
    <i class="bi bi-globe2 me-2 text-primary"></i> Get Started Today!
  </h3>

  <div class="d-flex flex-column align-items-center gap-3 fs-5 contact-info">
    <p class="mb-0">
      <i class="bi bi-house-door-fill text-primary me-2"></i>
      Main Website: 
      <a href="https://www.myTuitionWave.com" target="_blank" class="fw-semibold text-decoration-none link-primary">
        myTuitionWave.com
      </a>
    </p>
    <p class="mb-0">
      <i class="bi bi-building text-primary me-2"></i>
      Company Website: 
      <a href="https://www.mysoftcode.com" target="_blank" class="fw-semibold text-decoration-none link-primary">
        mysoftcode.com
      </a>
    </p>
    <p class="mb-0">
      <i class="bi bi-telephone-fill text-success me-2"></i>
      Contact: 
      <a href="tel:+94713246947" class="fw-semibold text-decoration-none link-dark">
        +94 71 324 6947
      </a>
    </p>
    <p class="mb-0">
      <i class="bi bi-envelope-fill text-danger me-2"></i>
      Email: 
      <a href="mailto:info@mysoftcode.com" class="fw-semibold text-decoration-none link-dark">
        info@mysoftcode.com
      </a>
    </p>
  </div>

  <p class="fw-bold text-secondary fs-5 mt-4">
    ✨ MyTuitionWave – Teaching Made Smarter, Payments Made Easier! ✨
  </p>

  <p class="small text-muted mt-3">
    🔗 Powered by 
    <a href="https://www.mysoftcode.com" target="_blank" class="fw-bold text-dark text-decoration-none">
      MySoftCode.com
    </a>
  </p>
</section>

  </div>
</template>

<script>
export default {
  name: "PackageSection",
  data() {
    return {
      packages: [
        { name: "Standard", duration: "1 Month", price: "Rs. 2,500", limit: "500 Students + 1 Subject", icon: "bi-gem" },
        { name: "Premium", duration: "3 Months", price: "Rs. 6,000", limit: "500 Students + 1 Subject", icon: "bi-star" },
        { name: "Smart", duration: "6 Months", price: "Rs. 10,500", limit: "500 Students + 1 Subject", icon: "bi-award" },
        { name: "Ultimate", duration: "12 Months", price: "Rs. 18,000", limit: "500 Students + 1 Subject", icon: "bi-infinity" }
      ]
    };
  }
};
</script>

<style scoped>
/*
  🎨 Professional Color Palette
  - Primary: #0d6efd (Bootstrap Blue)
  - Secondary: #6c757d (Muted Gray)
  - Dark: #212529 (Deep Black/Gray)
  - Success: #198754 (Vibrant Green)
  - Info: #0dcaf0 (Cyan)
  - Warning: #ffc107 (Yellow)
  - Danger: #dc3545 (Red)
*/

/* --- General Enhancements --- */

body {
  font-family: 'Poppins', sans-serif; /* A more modern font */
}

section {
  padding: 40px 0;
}

/* --- 3D Effects and Shadows --- */
.shadow-text {
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
}

.logo-3d:hover {
  transform: scale(1.1) rotateY(15deg);
  /* Updated hover shadow to match drop-shadow */
  filter: drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.3));
}

.shadow-3d {
  border-radius: 1rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.4s ease-in-out;
  border: none;
}
.hover-3d:hover {
  transform: translateY(-12px) scale(1.03);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
}

.icon-3d {
  filter: drop-shadow(2px 3px 4px rgba(0, 0, 0, 0.3));
  font-size: 1.5em;
}

/* --- Buttons --- */
.btn-3d-primary {
  background: linear-gradient(135deg, #0d6efd, #0b5ed7);
  border: none;
  color: #fff;
  border-radius: 50px;
  padding: 12px 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.btn-3d-primary::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150%;
  height: 150%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%) rotate(45deg);
  transition: all 0.5s ease;
  opacity: 0;
}
.btn-3d-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  color: #fff;
}
.btn-3d-primary:hover::after {
  opacity: 1;
}

.btn-outline-primary {
  border-radius: 50px;
  padding: 8px 25px;
  transition: all 0.3s ease;
}
.btn-outline-primary:hover {
  background-color: #0d6efd;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.hover-grow:hover {
  transform: scale(1.05);
}

/* --- Package Cards --- */
.package-card {
  border: 1px solid #e9ecef;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}
.package-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #0d6efd, #0dcaf0);
  z-index: 1;
}
.package-card .card-body {
  padding: 2.5rem 1.5rem;
}

.text-gradient-primary {
  background: linear-gradient(45deg, #0d6efd, #0dcaf0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- Features List --- */
.features-list li {
  font-size: 1.1em;
  line-height: 2.5;
  border-bottom: 1px dashed #dee2e6;
  transition: transform 0.2s ease;
}
.features-list li:hover {
  transform: translateX(5px);
}
.features-list li:last-child {
  border-bottom: none;
}
</style>